import type { EmailField as VaadinEmailField } from '@vaadin/email-field';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { Ref, ref } from 'lit/directives/ref.js';
import { TmInputFieldBase } from './tm-input-field.base';

// eslint-disable-next-line no-duplicate-imports
import '@vaadin/email-field';

export const tagName = 'tm-email-field';
@customElement(tagName)
export class TmEmailField extends TmInputFieldBase<string> {
    @property({ type: String })
    public allowedCharacters?: string;

    @property({ type: Number })
    public minLength?: number;

    @property({ type: Number })
    public maxLength?: number;

    private get emailField() {
        return (this.inputFieldRef as Ref<VaadinEmailField>).value;
    }

    protected validate() {
        if (!this.emailField) {
            return false;
        }

        return this.emailField.validate();
    }

    protected render() {
        const errorMessage = this.errorMessages?.join('\r\n');

        return html`
            <vaadin-email-field
                ${ref(this.inputFieldRef)}
                @value-changed=${(e: CustomEvent) => {
                    this.changeValue(e.detail.value);
                }}
                class="w-full"
                part="component"
                manual-validation
                .label=${this.label}
                value=${this.initial || ''}
                ?invalid="${!this.isValid}"
                error-message=${ifDefined(errorMessage)}
                placeholder=${ifDefined(this.placeholder)}
                allowed-char-pattern=${ifDefined(this.allowedCharacters)}
                min-length=${ifDefined(this.minLength)}
                max-length=${ifDefined(this.maxLength)}
                ?required=${this.required}
            >
            </vaadin-email-field>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmEmailField;
    }
}
